const MEDIA_STORAGE_URL = 'https://static.wixstatic.com/media/'

export const withMediaStorageUrl = (path: string) => `${MEDIA_STORAGE_URL}${path}`
